export default interface RamoModel {
    name:string;
    descricao:string;
}

export const tiposRamoList:RamoModel[] = [
    { name: "SAUDE", descricao: "Saúde" },
    { name: "ODONTO", descricao: "Odontologia" }
]
